export default "__VITE_ASSET__BVtt2rxF__"